import { Component, OnDestroy, ViewChild, OnInit, OnChanges } from "@angular/core";
import { MapComponent } from "./map.component";
import { Subject } from "rxjs";
import { MapService } from '../../commons/map.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Annotation } from '4d-mapper';

import { Constants } from "@src/app/commons/Constants";
import { MatSnackBar, MatDialog } from "@angular/material";
import { BaseComponent } from "@src/app/commons/BaseComponent";
import { XsApplicationEventsService } from "@src/app/xs/services/events/application-events.service";
import { XsAwait } from "@src/app/xs/controllers/await.class";

const Cesium = (<any>window).Cesium;


export interface CAMERA_OPTIONS {
  isAir?: boolean
  camera?: {
    heading: number
    pitch: number
    lat: number
    lng: number
    height: number
    axis: {
      lat: number
      lng: number
    }
  }
  bounds?: {
    coords: {
      lat: number
      lng: number
    },
    distance: number
  }
  flags?: any
  moveSpeed?: number
  panSpeed?: number
  cameraHomePos?: any
  axisLock?: any
  cache?: any
}

// <!-- <canvas id="cameraNavNorthCanvas" width="40" height="23" style="border:solid 1px yellow;position:fixed;top:200px;left:400px;" (mousedown)="doActionNorth()" (mouseup)="doUpActionNorth()"></canvas> -->

@Component({
    selector: 'camera-nav',
    template: `<div class="zoom-button">
    <canvas id='cameraNavCanvas' [width]="size" [height]="size"
            (mousedown)="doActionFromRegion($event)" (mouseup)="doUpActionFromRegion($event)"
            (mousemove)="update($event);" (mouseout)="update(false)"></canvas>
    </div>`,
  styleUrls:['./camera-nav.component.scss']
})
export class CameraNavComponent extends BaseComponent implements OnInit, OnDestroy {

    private ctx: any;
    // private northCtx: any;
    left = new Image();

    // @ViewChild('canvas',{static:false}) canvas:any
    // @ViewChild('northCanvas',{static:false}) northCanvas:any

    public birdViewMode = false;
    public isCameraClicked: boolean = false;

    moveRate:number = null;
    // heading:string = null;

    private cameraOptions: CAMERA_OPTIONS = {};
    size = 110;
    private ZOOM_AMOUNT = 10;

    flags = {
      looking: false,
      moveForward: false,
      moveBackward: false,
      moveUp: false,
      moveDown: false,
      moveLeft: false,
      moveRight: false,
      moveUpClick: false,
      moveDownClick: false,
      moveLeftClick: false,
      moveRightClick: false,
      lookDown: false,
      lookUp: false,
      lookRight: false,
      lookLeft: false,
      zoomInDown: false,
      zoomOutDown: false,
      zoomAllClick: false
    };

    viewer:any

    public camera_height = 50;
    handler
    cartographic: any ;
    // viewingRectangle:any
    private lookupdown: number = 0.000001;

    mousePosition : any;

    degreesPan = 4.0;
    degreesMove = 100.0;

    constructor( public router: Router, public snackBar: MatSnackBar, public dialog: MatDialog, 
      private mapComp:MapComponent, public mapService: MapService, private activatedRoute : ActivatedRoute,
      public applicationEvents:XsApplicationEventsService
    ) {
        super(router, snackBar, dialog);
    }

    init() {
      this.setup();
    }

    doneSetup:boolean = false;

    setup() {

      if ( this.doneSetup ) {
        return;
      }

      const me = this;

      XsAwait.until( 'mapService.viewer.scene', this ).then ( _ => {

        me.viewer = me.mapService.viewer;

        const canvas1 = <HTMLCanvasElement>document.getElementById('cameraNavCanvas');
        // const canvas2 = <HTMLCanvasElement>document.getElementById('cameraNavNorthCanvas');

        me.ctx = canvas1.getContext('2d');
        // this.northCtx = canvas2.getContext('2d');

        me.drawImages();
        me.ctx.fillStyle = '#f5f5f5';
        me.ctx.beginPath();
        me.ctx.arc(me.size / 2, me.size / 2, 30, 0, 2 * Math.PI, false);
        me.ctx.fill();
        me.ctx.closePath();
        me.update(false, true);
        me.handler = new Cesium.ScreenSpaceEventHandler(me.viewer.canvas);
        // this.viewingRectangle = this.viewer.camera.computeViewRectangle(this.viewer.scene.globe.ellipsoid, new Cesium.Rectangle());
        me.registerBirdViewModesEvents();

        me.doneSetup = true;

      });
      
    }

  enableBirdViewMode(value?: boolean) {
    if (!value) { // from birdview button
      this.birdViewMode = !this.birdViewMode;
    } else {
      this.birdViewMode = value;
    }
    if (this.birdViewMode) {
      this.getCameraOptions();
      this.panCamera();
    } else {
      this.removeActions();
    }
  }

  private getCameraOptions() {
    this.cameraOptions.isAir = true;
    this.cameraOptions.panSpeed = 0.01;
    this.cameraOptions.moveSpeed = 0.05;
    const cameraHomePos = Cesium.Cartesian3.fromDegrees(this.viewer.camera ? this.viewer.camera.lng : this.viewer.llng, this.viewer.camera ? this.viewer.camera.lat : this.viewer.ulat, this.viewer.camera && this.viewer.camera.height ? this.viewer.camera.height : 5, this.viewer.scene.globe.ellipsoid)
    this.cameraOptions.cameraHomePos = cameraHomePos;
    this.cameraOptions.camera = this.viewer.camera
    var bound = (<any>this.viewer).bounds
    if (bound) {
      this.cameraOptions.bounds = {
        coords: Cesium.Cartographic.toCartesian((<any>this.viewer).bounds),
        distance: bound.distance
      };
    }
  }

  private getCameraHeight(): number {
    var camera = this.viewer.scene.camera;
    var ellipsoid = this.viewer.scene.globe.ellipsoid;
    this.camera_height = ellipsoid.cartesianToCartographic(camera.position).height;
    return this.camera_height;
  }

  private panCamera() {


    var scene = this.viewer.scene;

    this.cameraOptions.moveSpeed = this.cameraOptions.moveSpeed || 0.05
    this.cameraOptions.panSpeed = this.cameraOptions.panSpeed || 0.02


    // disable the default event handlers
    scene.screenSpaceCameraController.enableRotate = false;
    scene.screenSpaceCameraController.enableTranslate = false;
    scene.screenSpaceCameraController.enableZoom = false;
    scene.screenSpaceCameraController.enableTilt = false;
    scene.screenSpaceCameraController.enableLook = false;
    scene.screenSpaceCameraController.minimumZoomDistance = 1.8;


    this.cameraOptions.flags = this.flags;

  }

  private getBirdView() {
    return this.birdViewMode;
  }

    private drawImages() {
        var right = new Image();
        right.src = 'assets/images/right.jpg';
        right.onload = () => {
            if (right.complete)
            this.ctx.drawImage(right, 87, 45, 20, 20); //region 0
        };
        var zoomall = new Image();
        zoomall.src = 'assets/images/zoomall.jpg';
        zoomall.onload = () => {
            if (zoomall.complete)
            this.ctx.drawImage(zoomall, 76, 77, 18, 18); //region 1
        };
        var down = new Image();
        down.src = 'assets/images/down.jpg';
        down.onload = () => {
            if (down.complete)
            this.ctx.drawImage(down, 45, 87, 20, 20); //region 2
        };
        /*
        var setting = new Image();
        setting.src = 'assets/images/setting.jpg';
        setting.onload = () => {
            if (setting.complete)
            this.ctx.drawImage(setting, 17, 77, 17, 17); //region 3
        };
*/
        this.left.src = 'assets/images/left.jpg';
        this.left.onload = () => {
            if (this.left.complete)
            this.ctx.drawImage(this.left, 2, 45, 20, 20); //region 4
        };

        var zoomout = new Image();
        zoomout.src = 'assets/images/zoomout.jpg';
        zoomout.onload = () => {
            if (zoomout.complete)
            this.ctx.drawImage(zoomout, 15, 18, 17, 17); //region 5
        };
        var up = new Image();
        up.src = 'assets/images/up.jpg';
        up.onload = () => {
            if (up.complete)
            this.ctx.drawImage(up, 46, 3, 20, 20); //region 6
        };
        var zoomin = new Image();
        zoomin.src = 'assets/images/zoomin.jpg';
        zoomin.onload = () => {
            if (zoomin.complete)
            this.ctx.drawImage(zoomin, 73, 15, 17, 17); //region 7
        };

        var moveup = new Image();
        moveup.src = 'assets/images/moveup.jpg';
        moveup.onload = () => {
            if (moveup.complete)
            this.ctx.drawImage(moveup, 47, 34, 15, 15);
        };
        var movedown = new Image();
        movedown.src = 'assets/images/movedown.jpg';
        movedown.onload = () => {
            if (movedown.complete)
            this.ctx.drawImage(movedown, 48, 64, 15, 15);
        };
        var moveleft = new Image();
        moveleft.src = 'assets/images/moveleft.jpg';
        moveleft.onload = () => {
            if (moveleft.complete)
            this.ctx.drawImage(moveleft, 33, 49, 15, 15);
        };
        var moveright = new Image();
        moveright.src = 'assets/images/moveright.jpg';
        moveright.onload = () => {
            if (moveright.complete)
            this.ctx.drawImage(moveright, 62, 48, 15, 15);
        };
    }


  doActionFromRegion(E) {

    if(this.mapComp.cameraLocked || this.mapComp.flyingToLine) return;
    var mx, my;
    if (E === false) {
      mx = this.size / 2;
      my = this.size / 2;
    } else {
      mx = E.offsetX;
      my = E.offsetY;
    }
    var mangle = (-Math.atan2(mx - this.size / 2, my - this.size / 2) + Math.PI * 2.5) % (Math.PI * 2);
    var mradius = Math.sqrt(Math.pow(mx - this.size / 2, 2) + Math.pow(my - this.size / 2, 2));

    if (mradius < 30 && my <= 45) {
      this.moveUp(true);
    }

    if (mradius < 30 && my >= 62) {
      this.moveDown(true);
    }

    if (mradius < 30 && mx <= 46) {
      this.moveLeft(true);
    }
    if (mradius < 30 && mx >= 62) {
      this.moveRight(true);
    }

    let i = 0;
    for (i = 0; i < 8; i++) {
      var angle = -Math.PI / 8 + i * (Math.PI / 4);

      if (((mangle > angle && mangle < (angle + Math.PI / 4)) || (mangle > Math.PI * 15 / 8 && i == 0)) && mradius <= this.size / 2 && mradius > 30) {

        switch (i) {
          case 0 :
            this.lookRight(true);
            break;
          case 1 :
            this.zoomAll(true);
            break;
          case 2 :
            this.lookDown(true);
            break;
          case 3 :
            // this.flyToLine(true);
            break;
          case 4 :
            this.lookLeft(true);
            break;
          case 5 :
            this.zoomOutDown(true);
            break;
          case 6 :
            this.lookUp(true);
            break;
          case 7 :
            this.zoomInDown(true);
            break;
        }
      }
    }
  }

  doUpActionFromRegion(E) {
    if(this.mapComp.cameraLocked  || this.mapComp.flyingToLine) return;
    // this.ctx.clearRect(0, 0, 224, 224);
    var mx, my;
    if (E === false) {
      mx = this.size / 2;
      my = this.size / 2;
    } else {
      mx = E.offsetX;
      my = E.offsetY;
    }

    var mangle = (-Math.atan2(mx - this.size / 2, my - this.size / 2) + Math.PI * 2.5) % (Math.PI * 2);
    var mradius = Math.sqrt(Math.pow(mx - this.size / 2, 2) + Math.pow(my - this.size / 2, 2));
    if (mradius < 30 && my <= 45) {
      this.moveUp(false);

    }
    if (mradius < 30 && my >= 62) {
      this.moveDown(false);

    }
    if (mradius < 30 && mx <= 46) {
      this.moveLeft(false);
    }
    if (mradius < 30 && mx >= 62) {
      this.moveRight(false);

    }
    let i = 0;
    for (i = 0; i < 8; i++) {
      var angle = -Math.PI / 8 + i * (Math.PI / 4);


      if (((mangle > angle && mangle < (angle + Math.PI / 4)) || (mangle > Math.PI * 15 / 8 && i == 0)) && mradius <= this.size / 2 && mradius > 30) {

        switch (i) {
          case 0 :
            this.lookRight(false);
            break;
          case 1 :
            this.zoomAll(false);
            break;
          case 2 :
            this.lookDown(false);
            break;
          case 3 :
            this.moveDown(false);
            break;
          case 4 :
            this.lookLeft(false);
            break;
          case 5 :
            this.zoomOutDown(false);
            break;
          case 6 :
            this.lookUp(false);
            break;
          case 7 :
            this.zoomInDown(false);
            break;
        }
      }
    }
  }

  private removeActions() {
    this.cameraOptions.flags.looking = false;
    this.cameraOptions.flags.moveForward = false;
    this.cameraOptions.flags.moveBackward = false;
    this.cameraOptions.flags.moveForward = false;
    this.cameraOptions.flags.moveUp = false;
    this.cameraOptions.flags.moveDown = false;
    this.cameraOptions.flags.moveLeft = false;
    this.cameraOptions.flags.moveRight = false;
    this.cameraOptions.flags.moveUpClick = false;
    this.cameraOptions.flags.moveDownClick = false;
    this.cameraOptions.flags.lookDown = false;
    this.cameraOptions.flags.lookUp = false;
    this.cameraOptions.flags.lookRight = false;
    this.cameraOptions.flags.lookLeft = false;
    this.cameraOptions.flags.zoomInDown = false;
    this.cameraOptions.flags.zoomOutDown = false;
    this.viewer.scene.screenSpaceCameraController.enableRotate = true;
    this.viewer.scene.screenSpaceCameraController.enableTranslate = true;
    this.viewer.scene.screenSpaceCameraController.enableZoom = true;
    this.viewer.scene.screenSpaceCameraController.enableTilt = true;
    this.viewer.scene.screenSpaceCameraController.enableLook = true;
    this.viewer.scene.screenSpaceCameraController.minimumZoomDistance = 1;
  }

  private lookRight(value: boolean) {
    this.mapService.viewer.camera.lookRight(Cesium.Math.toRadians(this.degreesPan));
  /*  this.enableBirdViewMode(value);
    this.flags.lookRight = value;*/
  }


  private zoomInDown(value: boolean) {
    // this.enableBirdViewMode(value);
    // this.flags.zoomInDown = value;
    this.zoomIn();
  }

  private zoomOutDown(value: boolean) {
    // this.enableBirdViewMode(value);
    // this.flags.zoomOutDown = value;
    this.zoomOut();
  }

  zoomIn() {
    this.mapService.viewer.camera.moveForward(Cesium.Math.toRadians(this.degreesMove));
    /*if (this.mapComp.refPin.position && this.mapComp.refPin.position._value.x < 50000 && this.mapComp.refPin.position._value.z < 50000 && this.mapComp.refPin.position._value.z < 50000) {
      this.mapService.viewer.camera.moveBackward(Cesium.Math.toRadians(10.0));
    }else{
      this.getCameraHeight();
      this.viewer.camera.zoomIn(this.camera_height / this.ZOOM_AMOUNT);
    }
*/
  }

  zoomOut() {
    this.mapService.viewer.camera.moveBackward(Cesium.Math.toRadians(this.degreesMove));
    /*if (this.mapComp.refPin.position && this.mapComp.refPin.position._value.x < 50000 && this.mapComp.refPin.position._value.z < 50000 && this.mapComp.refPin.position._value.z < 50000) {
      this.mapService.viewer.camera.moveForward(Cesium.Math.toRadians(10.0));
    }else{
      this.getCameraHeight();
      this.viewer.camera.zoomOut(this.camera_height / this.ZOOM_AMOUNT);
    }*/
  }


  private zoomAll(value: boolean) {
    this.enableBirdViewMode(value);
    this.flags.zoomAllClick = value;
  }

  private lookDown(value: boolean) {
    this.mapService.viewer.camera.lookDown(Cesium.Math.toRadians(this.degreesPan));
   /* this.enableBirdViewMode(value);
    this.flags.lookDown = value;*/
  }

  private moveDown(value: boolean) {
    this.mapService.viewer.camera.moveDown(Cesium.Math.toRadians(this.degreesMove));
   /* this.enableBirdViewMode(value);
    this.flags.moveDownClick = value;*/
  }

  private moveLeft(value: boolean) {
    this.mapService.viewer.camera.moveLeft(Cesium.Math.toRadians(this.degreesMove));
    /*this.enableBirdViewMode(value);
    this.flags.moveLeftClick = value;*/
  }

  private moveRight(value: boolean) {
    this.mapService.viewer.camera.moveRight(Cesium.Math.toRadians(this.degreesMove));
    /*this.enableBirdViewMode(value);
    this.flags.moveRightClick = value;*/
  }

  private lookLeft(value: boolean) {
    this.mapService.viewer.camera.lookLeft(Cesium.Math.toRadians(this.degreesPan));
    /*this.enableBirdViewMode(value);
    this.flags.lookLeft = value;*/
  }

  private moveUp(value: boolean) {
    this.mapService.viewer.camera.moveUp(Cesium.Math.toRadians(this.degreesMove));
   /* this.enableBirdViewMode(value);
    this.flags.moveUpClick = value;*/
  }

  private lookUp(value: boolean) {
    this.mapService.viewer.camera.lookUp(Cesium.Math.toRadians(this.degreesPan));
  /*  this.enableBirdViewMode(value);
    this.flags.lookUp = value;*/
  }


  private registerBirdViewModesEvents() {

    var startMousePosition;
    var eventStarted = 0;
    var isFast = false;
    var canvas = this.viewer.canvas;
    var ellipsoid = this.viewer.scene.globe.ellipsoid;
    var camChangeSub = new Subject();
    this.handler.camChange = camChangeSub.asObservable();
    var screenCenter = new Cesium.Cartesian2(this.viewer.scene.canvas.width / 2, this.viewer.scene.canvas.height / 2);

    this.handler.setInputAction((movement) => {
      if (this.birdViewMode) {
        this.flags.looking = true;
      }
      this.mousePosition = startMousePosition = Cesium.Cartesian3.clone(movement.position);

    }, Cesium.ScreenSpaceEventType.LEFT_DOWN);

    this.handleMouseMove();

    this.handler.setInputAction((position) => {
      if (this.birdViewMode) {
        this.flags.looking = false;
      }
    }, Cesium.ScreenSpaceEventType.LEFT_UP);

    this.handler.setInputAction((position) => {
      if (this.birdViewMode) {
        if (position > 0) {
          this.flags['moveForward'] = true;
          this.flags['moveBackward'] = false;
        }
        else {
          this.flags['moveBackward'] = true;
          this.flags['moveForward'] = false;
        }
        var isFast;
        isFast = true
        eventStarted++;
        var myEvent = eventStarted;
        setTimeout(() => {
          if (eventStarted == myEvent) {
            this.flags['moveForward'] = false;
            this.flags['moveBackward'] = false;
            isFast = false

          }
        }, 100)
      }
    }, Cesium.ScreenSpaceEventType.WHEEL);


    this.handler.setInputAction((position) => {
      if (this.birdViewMode) {
        if (position.distance.startPosition.y - position.distance.endPosition.y < 0) {
          this.flags['moveForward'] = true;
          this.flags['moveBackward'] = false;
        }
        else {
          this.flags['moveBackward'] = true;
          this.flags['moveForward'] = false;
        }
        isFast = true

        eventStarted++;
        var myEvent = eventStarted;
        setTimeout(() => {
          if (eventStarted == myEvent) {
            this.flags['moveForward'] = false;
            this.flags['moveBackward'] = false;
            isFast = false
          }
        }, 100)
      }

    }, Cesium.ScreenSpaceEventType.PINCH_MOVE);


    document.addEventListener('keydown', (e) => {
      if (this.birdViewMode) {

        var flagName = this.getFlagForKeyCode(e.keyCode);
        if (typeof flagName !== 'undefined') {
          this.flags[flagName] = true;
        }
      }
    }, false);

    document.addEventListener('keyup', (e) => {
      if (this.birdViewMode) {
        var flagName = this.getFlagForKeyCode(e.keyCode);
        if (typeof flagName !== 'undefined') {
          this.flags[flagName] = false;
        }
      }
    }, false);

    let me = this;

    this.viewer.clock.onTick.addEventListener((clock) => {

      // me.heading = (this.viewer.camera.heading * 180 / Math.PI).toFixed(1);

      // this.viewingRectangle = this.viewer.camera.computeViewRectangle(this.viewer.scene.globe.ellipsoid, new Cesium.Rectangle());
      /*
      this.northCtx.clearRect(0, 0, 40, 40);
      this.northCtx.globalAlpha = 1;
      this.northCtx.clearRect(0, 0, 40, 40);

      this.northCtx.font = '10pt Sans-serif';

      this.northCtx.textAlign = 'left';
      this.northCtx.textBaseline = 'center';

      this.northCtx.strokeStyle = '#4c5049';
      this.northCtx.lineWidth = 2;
      let t = (this.viewer.camera.heading * 180 / Math.PI).toFixed(1);
      if (t.length === 3) {
        t = '  ' + t;
      }
      if (t.length === 4) {
        t = ' ' + t;
      }
      this.northCtx.strokeText(t + '°', 0, 20);
      this.northCtx.fillStyle = 'white';
      this.northCtx.fillText(t + '°', 0, 20);
      */

      if (this.getBirdView()) {
        if (!this.cameraOptions.cache) {
          this.cameraOptions.cache = {}
        }
        if (this.flags.looking) {
          var width = canvas.clientWidth;
          var height = canvas.clientHeight;
          // Change movement speed based on the distance of the camera to the surface of the ellipsoid.
          var cameraHeight = ellipsoid.cartesianToCartographic(this.viewer.camera.position).height;
          var moveRate = cameraHeight / 100.0;

          this.moveRate = moveRate;

          // Coordinate (0.0, 0.0) will be where the mouse was clicked.
          var x = 0;
          var y = 0;
          if (this.mousePosition && this.mousePosition.x && startMousePosition && startMousePosition.x) {
            x = (this.mousePosition.x - startMousePosition.x) / width;
            y = -(this.mousePosition.y - startMousePosition.y) / height;
          }
          var lookFactor = 0.02;
          camChangeSub.next();
          if (this.cameraOptions.cache.axis) {

            this.cameraOptions.cache.heading += x * 0.2
            this.cameraOptions.cache.pitch += y * 0.1
            this.updateAxis(this.cameraOptions, this.viewer.camera)
          }
          else {
            this.viewer.camera.lookRight(x * lookFactor);
            this.viewer.camera.lookUp(y * lookFactor);
          }
        }


        if (this.flags.moveForward || this.flags.moveBackward) {
          if (this.cameraOptions.cache.axis) {
            if (!this.cameraOptions.cache.distance)
              this.cameraOptions.cache.distance = 5

            this.cameraOptions.cache.distance -= (this.flags.moveForward ? 1 : -1) * 0.1;
            camChangeSub.next(
              this.updateAxis(this.cameraOptions, this.viewer.camera)
            )
          }
          else {

            var ray = this.viewer.camera.getPickRay(screenCenter)
            var speed = (this.flags.moveForward ? this.cameraOptions.moveSpeed : -this.cameraOptions.moveSpeed) * (isFast ? 3 : 1)

            console.log('camera-nav :: clock() ray_picking expensive going on ...');

            if (cameraHeight > 10)
              speed += (this.flags.moveForward ? 1 : -1) * cameraHeight * 0.01;
            var point = Cesium.Ray.getPoint(ray, speed);
            var coords = Cesium.Cartographic.fromCartesian(point, ellipsoid)
            if (this.cameraOptions.bounds && (Cesium.Cartesian3.distance(this.cameraOptions.bounds.coords, point) > this.cameraOptions.bounds.distance)) {
              // stop
              console.log('toobar')
            }
            else if (coords.height > 6) {
              this.viewer.camera.setView({
                destination: point,
                orientation: new Cesium.HeadingPitchRoll(this.viewer.camera.heading, this.viewer.camera.pitch, 0)
              });
            }
            else {
              coords.height = 6
              camChangeSub.next(coords)
              var newPoint = Cesium.Cartographic.toCartesian(coords, ellipsoid)
              this.viewer.camera.setView({
                destination: newPoint,
                orientation: new Cesium.HeadingPitchRoll(this.viewer.camera.heading, this.viewer.camera.pitch, 0)
              });
            }
          }

        }
        if (this.flags.zoomAllClick) {
          this.mapService.helper.sendCameraTo(this.mapService.sceneTransforms[0]);
        }
        if (this.flags.moveUp) {
          if (this.cameraOptions.cache.axis) {
            camChangeSub.next();
            this.cameraOptions.cache.axis.height += 0.1
            this.updateAxis(this.cameraOptions, this.viewer.camera)
          }
          else if (cameraHeight < 100)
            this.viewer.camera.moveUp(moveRate);
        }
        if (this.flags.lookUp) {

          this.viewer.camera.lookUp((this.lookupdown * this.getCameraHeight()) / (this.getCameraHeight() / 1700));
        }
        if (this.flags.moveUpClick) {

          this.viewer.camera.moveUp(this.getCameraHeight() / 700);
        }

        if (this.flags.moveDownClick) {

          this.viewer.camera.moveDown(this.getCameraHeight() / 700);
        }

        if (this.flags.moveLeftClick) {


          this.viewer.camera.moveLeft(this.getCameraHeight() / 700);
        }

        if (this.flags.moveRightClick) {


          this.viewer.camera.moveRight(this.getCameraHeight() / 700);
        }

        if (this.flags.moveDown) {
          if (this.cameraOptions.cache.axis) {
            camChangeSub.next();
            this.cameraOptions.cache.axis.height -= 0.1
            this.updateAxis(this.cameraOptions, this.viewer.camera)
          }
          else if (cameraHeight > 6)
            this.viewer.camera.moveDown(moveRate);
        }

        if (this.flags.lookDown) {
          this.viewer.camera.lookDown((this.lookupdown * this.getCameraHeight()) / (this.getCameraHeight() / 1700));
        }

        if (this.flags.moveLeft) {
          if (this.cameraOptions.cache.axis) {
            camChangeSub.next();
            this.cameraOptions.cache.heading -= 0.1
            this.updateAxis(this.cameraOptions, this.viewer.camera)
          }
          else
            this.viewer.camera.lookLeft(this.cameraOptions.panSpeed);
        }
        if (this.flags.lookRight) {
          this.viewer.camera.lookRight((this.lookupdown * this.getCameraHeight()) / (this.getCameraHeight() / 1700));
        }
        if (this.flags.lookLeft) {
          this.viewer.camera.lookLeft((this.lookupdown * this.getCameraHeight()) / (this.getCameraHeight() / 1700));
        }


        if (this.flags.moveRight) {
          if (this.cameraOptions.cache.axis) {
            camChangeSub.next();
            this.cameraOptions.cache.heading += 0.1
            this.updateAxis(this.cameraOptions, this.viewer.camera)
          }
          else
            this.viewer.camera.lookRight(this.cameraOptions.panSpeed);
        }
      }
    });
  }


  private getFlagForKeyCode(keyCode) {
    switch (keyCode) {
      case 'Q'.charCodeAt(0):
        return 'moveUp';
      case 57:
        return 'moveUp';
      case 33:
        return 'moveUp';
      case 'E'.charCodeAt(0):
        return 'moveDown';
      case 51:
        return 'moveDown';
      case 34:
        return 'moveDown';


      case 'W'.charCodeAt(0):
        return 'moveForward';
      case 38:
        return 'moveForward';
      case 56:
        return 'moveForward';

      case 'S'.charCodeAt(0):
        return 'moveBackward';

      case 40:
        return 'moveBackward';

      case 50:
        return 'moveBackward';

      case 'D'.charCodeAt(0):
        return 'moveRight';
      case 39:
        return 'moveRight';
      case 54:
        return 'moveRight';

      case 'A'.charCodeAt(0):
        return 'moveLeft';
      case 37:
        return 'moveLeft';
      case 52:
        return 'moveLeft';
      default:
        console.log('key code ' + keyCode)
        return undefined;
    }
  }


  private updateAxis(options: CAMERA_OPTIONS, camera: any, animate: boolean = false) {
    var d = options.cache.distance || 10
    var newPoint = this.getCameraPosForPointCarto(options.cache.axis, options.cache.heading, Math.sin(-options.cache.pitch) * d, d)
    if (animate)
      camera.flyTo({
        destination: newPoint,
        duration: 0.3,
        orientation: new Cesium.HeadingPitchRoll(options.cache.heading, options.cache.pitch, 0)
      });

    else
      camera.setView({
        destination: newPoint,
        orientation: new Cesium.HeadingPitchRoll(options.cache.heading, options.cache.pitch, 0)
      });

    return newPoint
  }


  private getCameraPosForPointCarto(startPoint: any, headingRads: number, heightDelta: number, distance: number = 5) {
    var heading = headingRads;
    var earthRadius = Cesium.Ellipsoid.WGS84.maximumRadius
    var verticalAngle = -distance / earthRadius;
    var endLatitude = Math.asin(Math.sin(startPoint.latitude) * Math.cos(verticalAngle) +
      Math.cos(startPoint.latitude) * Math.sin(verticalAngle) * Math.cos(heading));
    var endLongitude = startPoint.longitude + Math.atan2(Math.sin(heading) * Math.sin(verticalAngle) * Math.cos(startPoint.latitude),
      Math.cos(verticalAngle) - Math.sin(startPoint.latitude) * Math.sin(endLatitude));
    return Cesium.Cartesian3.fromRadians(endLongitude, endLatitude, startPoint.height + heightDelta);
  }


  update(E, firstTime?: boolean) {

    if ( !this.ctx ) {
      return;
    }

    var mx, my;
    if (E === false) {
      mx = this.size / 2;
      my = this.size / 2;
    } else {
      mx = E.offsetX;
      my = E.offsetY;

    }

    var mangle = (-Math.atan2(mx - this.size / 2, my - this.size / 2) + Math.PI * 2.5) % (Math.PI * 2);
    var mradius = Math.sqrt(Math.pow(mx - this.size / 2, 2) + Math.pow(my - this.size / 2, 2));

    let i = 0;
    for (i = 0; i < 8; i++) {
      var angle = -Math.PI / 8 + i * (Math.PI / 4);

      if (((mangle > angle && mangle < (angle + Math.PI / 4)) || (mangle > Math.PI * 15 / 8 && i == 0)) && mradius <= this.size / 2 && mradius > 30) {
        this.ctx.fillStyle = '#5a5a5a';
      } else {
        this.ctx.fillStyle = '#4c4c4c';
      }
      if (firstTime) {
        this.ctx.beginPath();
        this.ctx.moveTo(this.size / 2, this.size / 2);
        this.ctx.lineTo(this.size / 2 + Math.cos(angle) * this.size / 2, this.size / 2 + Math.sin(angle) * this.size / 2);

        this.ctx.arc(this.size / 2, this.size / 2, this.size / 2, angle, angle + Math.PI / 4, false);
        this.ctx.fill();
        this.ctx.lineTo(this.size / 2, this.size / 2);
      }
    }
    if (firstTime) {
      this.ctx.closePath();
      this.ctx.fillStyle = '#f5f5f5';
      this.ctx.beginPath();
      this.ctx.arc(this.size / 2, this.size / 2, 30, 0, 2 * Math.PI, false);
      this.ctx.fill();
      this.ctx.closePath();
    }
  }
  doActionNorth() {
      if(this.mapComp.cameraLocked  || this.mapComp.flyingToLine) return;
    this.viewer.camera.setView({
      orientation: {
        heading: this.viewer.camera.heading + 5 * Math.PI / 180,
        pitch: this.viewer.camera.pitch,
        roll: this.viewer.camera.roll
      }
    });
  }

  doUpActionNorth() {
    if(this.mapComp.cameraLocked  || this.mapComp.flyingToLine) return;
    this.viewer.camera.setView({
      orientation: {
        heading: this.viewer.camera.heading,
        pitch: this.viewer.camera.pitch,
        roll: this.viewer.camera.roll
      }
    });
  }

  private handleMouseMove() {
    this.handler.setInputAction((movement) => {
      this.mousePosition = movement.endPosition;
      var cartesian = this.viewer.scene.pickPosition(movement.endPosition);
      if(cartesian){
        this.cartographic = Cesium.Cartographic.fromCartesian(cartesian);
      }else{
        this.cartographic = undefined;
      }

    }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);
  }

  private flyToLine(b: boolean) {
    var t = new Annotation(this.mapComp.fourD.V).set({
      name: 'flyToLine',
      project: this.mapService.currentProject,
      annotationMode: 'flyToLine'
    });
    t['icon'] = 'ruler-triangle';
    t['showPermanent'] = false;

    this.mapService.setNewAnnotation(t);
    if(this.mapService.annotations && this.mapService.annotations.length > 0){
      let flyToLineAnnotation = this.mapService.annotations.filter(v => v['annotationMode'] === 'flyToLine')
      if(flyToLineAnnotation && flyToLineAnnotation.length > 0){
        this.router.navigate(['flyToLine', flyToLineAnnotation[0].id], {relativeTo: this.activatedRoute});
      }else{
        this.router.navigate(['flyToLine', 'new'], {relativeTo: this.activatedRoute});
      }
    }else{
      this.router.navigate(['flyToLine', 'new'], {relativeTo: this.activatedRoute});
    }


  }
}

